<template>
  <LinkField
    v-bind="linkField[0]"
    class="relative inline-block"
    @click.native="SET_ACTIVE_NAV_ITEM_INDEX(null)"
    no-tracking
  >
    <CldnImg
      v-if="image[0]"
      :src="image[0].url"
      :alt="image[0].title"
      sizes="50vw sm:50vw md:20vw lg:15vw xl:15vw 2xl:15vw"
      class="w-full select-none"
    />
    <div class="inset-4 absolute flex items-end">
      <BarText :text="heading" class="fluid-lg leading-tight font-medium" />
    </div>
  </LinkField>
</template>

<script setup>
import LinkField from '@/components/common/LinkField';
import CldnImg from '@/components/CldnImg';
import BarText from '@/components/BarText';
import { useMainNavStore } from '@/stores/main-nav';

const props = defineProps({
  heading: {
    type: String,
    default: null,
  },
  image: {
    type: Array,
    default: () => [],
  },
  linkField: {
    type: Array,
    default: () => [],
  },
});

const mainNavStore = useMainNavStore();
const SET_ACTIVE_NAV_ITEM_INDEX = (value) => {
  mainNavStore.setActiveNavItemIndex(value);
};
</script>
